export const alertMessageAction = {
    SET_MESSAGE: "SET_MESSAGE",
    REMOVE_MESSAGE: "REMOVE_MESSAGE"
};